import React from "react";

const LoadingCircle: React.FC = () => {
  return (
    <div className="flex justify-center items-center">
      <div className="relative w-20 h-20">
        <div
          className="absolute inset-0 rounded-full border-4 border-brand-500 border-t-transparent animate-spin"
        ></div>
      </div>
    </div>
  );
};

export default LoadingCircle;
